import { Component } from '@angular/core';

@Component({
  selector: 'app-email-en',
  imports: [],
  templateUrl: './email-en.html',
  styleUrl: './email-en.css',

})
export class English {}
